import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateVRFSystem } from '../../redux/vrf/vrf_system_actions';

const mapStateToProps = state => ({
  isDuplicating: state.vrfSystem.isDuplicating,
  errorMessage: state.vrfSystem.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateVRFSystem(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/VRFSystemDuplicateModal.js